import { useState } from 'react';
import {
  StyledBroadsiderInventorySelector,
  StyledCategorySelector,
  CategoryButton
} from './BroadsiderInventorySelector.styled';
import { BroadsiderInventoryItem } from '../';
import { AppContext } from '../../providers/AppContext';
import { useContext } from 'react';
import { useAudio } from '../../providers/AudioContext';

const CategorySelector = ({ categories, selectedCategory, setSelectedCategory }) => {
  const { playSFX } = useAudio();
  const sortedCategories = Object.keys(categories).sort((a, b) => categoryOrder(a) - categoryOrder(b));
  return (
    <StyledCategorySelector>
      {sortedCategories.map((c) => (<CategoryButton onMouseEnter={() => playSFX('hover')} onClick={() => { playSFX('button'); setSelectedCategory(c); }} $selected={c === selectedCategory}>{c}</CategoryButton>))}
    </StyledCategorySelector>
  );
};

const categoryOrder = (category) => {
  if (category === 'weapon') {
    return 0;
  }
  if (category === 'armor' || category === 'armour') {
    return 1;
  }
  return 2;
};

const BroadsiderInventorySelector = ({ slot }) => {
  const { playSFX } = useAudio();
  const { equipItem } = useContext(AppContext);
  const onItemClick = (item) => {
    const sound = item.isEquipped() ? 'unequip' : `equip_${item.getType()}`;
    playSFX(sound);
    equipItem(item, slot.type, !item.isEquipped());
  };

  const categories = {};
  slot.options.forEach((o) => {
    const categoryName = o.getType();
    if (!categories[categoryName]) {
      categories[categoryName] = [];
    }
    categories[categoryName].push(o);
  });

  const [selectedCategory, setSelectedCategory] = useState(Object.keys(categories).sort((a, b) => categoryOrder(a) - categoryOrder(b))[0] ?? null);

  const categoryItems = categories[selectedCategory] || [];
  return (
    <StyledBroadsiderInventorySelector>
      <div className='broadsider-inv-selector-content-wrapper'>
      <div className='broadsider-inv-selector-content'>
        <div className='broadsider-inv-selector-title-holder'>
          <div className='broadsider-inv-selector-title-stub-short selected' />
          <div className='broadsider-inv-selector-logo-and-title'>
            <img className='broadsider-inv-selector-logo' src={`/assets/inv_logo_${selectedCategory}.svg`} />
            <div className='broadsider-inv-selector-title'>{selectedCategory}</div>
          </div>
          <div className='broadsider-inv-selector-title-stub-long' />
          <div className='broadsider-inv-selector-title-number'>{categoryItems.length}</div>
          <div className='broadsider-inv-selector-title-stub-short' />
        </div>
        <div className='broadsider-inv-selector-holder'>
          <CategorySelector categories={categories} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory}/>
          <div className='broadsider-inv-selector-items'>
            {categoryItems.map((o, index) => (<BroadsiderInventoryItem key={`inv-item-${index}`} item={o} isSelected={slot.equipped === o} onClick={() => onItemClick(o)}/>))}
          </div>
        </div>
      </div>
      </div>
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-tl' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-tr' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-bl' />
      <div className='broadsider-inv-selector-corner broadsider-inv-selector-corner-br' />
    </StyledBroadsiderInventorySelector>
  )
};

export default BroadsiderInventorySelector;
